import styled from 'styled-components';
import { withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import checkMark from '../../../assets/img/checkbox-check-mark.svg';

const CustomCheckBox = styled.div`
  height: auto;
  margin: 0px;
  line-height: 40px;
  position: relative;
  input {
    display: none;
  }
  label {
    cursor: pointer;
    > span {
      display: inline-block;
      line-height: 30px;
      vertical-align: top;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: ${props => (props.isPlan ? '600' : 'auto')};
      font-size: ${props => (props.isPlan ? '16px' : 'auto')};
      width: ${props => (props.width ? props.width : 'auto')};
      color: ${props => (props.selected ? getColor('primary') : 'auto')};
      ${withQuery.xs.down()} {
        font-size: 16px;
        width: 175%;
      }
    }
  }
  label > span:before {
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 3px;
    content: '';
    width: ${props => (props.isRadioButtom ? '14px' : '15px')};
    height: ${props => (props.isRadioButtom ? '14px' : '15px')};
    border: solid ${props => (props.isRadioButtom ? '1.5px' : '1px')};
    border-radius: ${props => (props.isRadioButtom ? '100%' : '2px')};
  }
  input:checked + span:before {
    content: '';
    background-color: ${getColor('primary')};
    background-image: url(${props => (props.isRadioButtom ? 'none' : checkMark)});
    border-color: ${getColor('primary')};
    padding: ${props => (props.isRadioButtom ? '2px' : '0px')};
    width: ${props => (props.isRadioButtom ? '10px' : '15px')};
    height: ${props => (props.isRadioButtom ? '10px' : '15px')};
    background-repeat: no-repeat;
    background-clip: content-box;
    background-size: 8px 6px;
    background-position: 50% 40%;
  }
`;

export { CustomCheckBox };
